import { useState, useEffect } from 'react';

/**
 * Retorna true se o navegador reporta conexão ativa.
 * Escuta os eventos nativos 'online' e 'offline' da janela.
 *
 * NOTA: navigator.onLine pode ser true mesmo sem acesso à internet real
 * (ex: rede local sem saída). Para o Player, é suficiente — o Supabase
 * Realtime vai falhar por conta própria se não conseguir conectar.
 */
export function useOnlineStatus(): boolean {
  const [isOnline, setIsOnline] = useState(() => navigator.onLine);

  useEffect(() => {
    const handleOnline  = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online',  handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online',  handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return isOnline;
}
